export default __webpack_public_path__ + "static/media/SENAIT_FR_SEQ07.eb47aee0.mp3";